export default __webpack_public_path__ + "static/media/54_mobile.5fc7fa60.jpg";